var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"d-block m-0 py-3 border-bottom"},[_vm._v("\n    "+_vm._s(_vm.$t('taxi.pages.summary.payment_ecard'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }